// extracted by mini-css-extract-plugin
module.exports = {"sidebarMainLink":"sidebarnavlink_sidebarMainLink__1A_eB","sidebarLinkActive":"sidebarnavlink_sidebarLinkActive__3w9Zf","sidebarLinkIcon":"sidebarnavlink_sidebarLinkIcon__t0d8F"};